import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen w-full bg-black text-white selection:bg-white selection:text-black" data-id="element-131">
      <Header data-id="element-132" />
      <HeroSection data-id="element-133" />
      <AboutSection data-id="element-134" />
      <AchievementsSection data-id="element-135" />
      <OfferSection data-id="element-136" />
      <Footer data-id="element-137" />
    </main>;
}